import { Badge } from "@/components/ui/badge";

const SUGGESTIONS = [
  "How are my calls going?",
  "Analyze my recent conversations",
  "Help me set up a genie",
  "Where can I edit my genie's branding?",
  "How do I configure links and images shown in chat?",
];

interface SuggestionChipsProps {
  onSelect: (text: string) => void;
  disabled?: boolean;
}

const SuggestionChips = ({ onSelect, disabled }: SuggestionChipsProps) => (
  <div className="flex flex-wrap gap-2 justify-center">
    {SUGGESTIONS.map((text) => (
      <Badge
        key={text}
        className="bg-primary/10 text-primary hover:bg-primary/20 cursor-pointer px-3 py-1.5 text-sm font-normal transition-colors select-none"
        onClick={() => !disabled && onSelect(text)}
      >
        {text}
      </Badge>
    ))}
  </div>
);

export default SuggestionChips;
